import { ref } from "vue";
import useApi from "@/services/useApi";
import { useStore } from "vuex";

export default function useActivationViber(payload) {
    const { api, reactiveHeaders } = useApi();
    const store = useStore();
    const activationStatusNumber = ref();
    const payloadLinkActivationViber = ref({}); // {description, status, ?data: {link}}
    const statusNumberActivation = ref({});

    const initiateActivationViber = (number) => {
        let result = "";
        return api
            .post(
                "/api/activation/viber",
                { number },
                { headers: reactiveHeaders.value }
            )
            .then((response) => {
                result = response.data;
                return response.data;
            })
            .catch((error) => {
                // console.error('Error initiateActivationViber ', error.message); initiateActivation
                result = error.response?.data;
            })
            .finally(() => {
                switch (result.description) {
                    case "Something went wrong":
                        activationStatusNumber.value = "oops";
                        break;
                    case "Number activated":
                        activationStatusNumber.value = "activated";
                        break;
                    case "Pending number activation":
                    case "Activation process initiated":
                    case "Pending link generation":
                        activationStatusNumber.value = "generationCode";
                        break;
                    default:
                        activationStatusNumber.value = result.description;
                        break;
                }
            });
    };

    const getLinkActivationViber = (number) => {
        let result = "";
        return api
            .post(
                "/api/activation/viber/link",
                { number },
                { headers: reactiveHeaders.value }
            )
            .then((response) => {
                result = response.data;
                return response.data;
            })
            .catch((error) => {
                result = error.response?.data;
            })
            .finally(() => {
                if (result?.status === "Success") {
                    payloadLinkActivationViber.value = result;
                    if (result?.data?.link) {
                        store.commit(
                            "activation/SET_QR_LINK",
                            result.data.link
                        );
                        store.commit(
                            "activation/SET_QR_LINK",
                            result.data.link
                        );
                    }
                } else payloadLinkActivationViber.value = result?.description;

                return payloadLinkActivationViber.value;
            });
    };

    // Route::post('activation/viber/status', [ActivationStatusController::class, 'checkStatus']);
    const getStatusActivationViber = (number) => {
        return api
            .post(
                "/api/activation/viber/status",
                { number },
                { headers: reactiveHeaders.value }
            )
            .then((response) => {
                if (response.data.status === "Error") {
                    statusNumberActivation.value = "oops";
                } else
                    switch (response.data.description) {
                        case "Number requires activation":
                            statusNumberActivation.value = "timeOver";
                            break;
                        case "Pending link generation":
                            if (store.state.activation.qrLink) {
                                statusNumberActivation.value = "oops";
                            }
                            break;
                        case "Number activated":
                            statusNumberActivation.value = "activated";
                            break;
                        case "Pending number activation":
                            //  отрабатывает на этапе генерации кода БЕЗ пушера
                            if (!store.state.activation.qrLink) {
                                getLinkActivationViber(number);
                            } else statusNumberActivation.value = "scanCode";
                            break;
                        case "Something went wrong":
                        default:
                            statusNumberActivation.value = "oops";
                            break;
                    }
                return statusNumberActivation.value;
            })
            .catch((error) => {
                console.error("Error getStatusActivationViber ", error);
                statusNumberActivation.value = "oops";
            });
    };

    return {
        initiateActivationViber,
        activationStatusNumber,
        getLinkActivationViber,
        payloadLinkActivationViber, // ! remove
        getStatusActivationViber,
        statusNumberActivation,
    };
}
